import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index/index'
import yuyueindex from '@/components/yuyue/index'
import mineindex from '@/components/mine/index'
import yuyuedetail from '@/components/yuyue/detail'
import bindInfo from '@/components/mine/bindInfo'
import myAppointment from '@/components/mine/myAppointment'
import doctorindex from '@/components/doctor/index'
import doctorBindIdCard from '@/components/doctor/bindIdCard'
import doctorAppointments from '@/components/doctor/appointments'

Vue.use(Router)

const router = new Router({
  routes: [
    {path: '/index/index',name:'index',meta:{title:"首页"},component: index},
    {path: '/yuyue/index',name:'yuyueindex',meta:{title:"预约"},component: yuyueindex},
	{path: '/mine/index',name:'mineindex',meta:{title:"我的"},component: mineindex},
	{path: '/yuyue/detail',name:'yuyuedetail',meta:{title:"预约详情"},component: yuyuedetail},
	{path: '/mine/bindInfo',name:'bindInfo',meta:{title:"绑定信息"},component: bindInfo},
	{path: '/mine/myAppointment',name:'myAppointment',meta:{title:"我的预约"},component: myAppointment},
	{path: '/doctor/index',name:'doctorindex',meta:{title:"医生端"},component: doctorindex},
	{path: '/doctor/bindIdCard',name:'doctorBindIdCard',meta:{title:"绑定身份证"},component: doctorBindIdCard},
	{path: '/doctor/appointments',name:'doctorAppointments',meta:{title:"预约患者"},component: doctorAppointments},
  ]
})
router.beforeEach((to,from,next)=>{
    if(to.meta.title){
        document.title = to.meta.title
    }
    next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js